import { http } from './config'
import { httpNoLoading } from './configNoLoading'

export default {
    createOrcamento: (data) => {
        return http.post('orcamento', data)
    },
    getByCodigo: (id) => {
        return http.get('orcamento/' + id, { silent: true })
    },
    getCompleta: (id) => {
        return http.get('orcamento/' + id + '/completa', { silent: true })
    },
    getOrcamentoItens: (id) => {
        return http.get('orcamento/' + id + '/itens', { silent: true })
    },
    printOrcamento: (id, status = null) => {
        if(status){
            return http.get('orcamento/' + id + '/imprimir/'+status , {
                responseType: 'blob',
                timeout: 60000,
            })
        } else {
            return http.get('orcamento/' + id + '/imprimir', {
                responseType: 'blob',
                timeout: 60000,
            });
        }
    },
    getProductChangeAlerts: (id) => {
        return httpNoLoading.get('orcamento/' + id + '/alertas-de-mudanca')
    },
    getProductItemChangeAlerts: (orcamento_id, orcamento_item_id) => {
        return httpNoLoading.get('orcamento/' + orcamento_id + '/item/' + orcamento_item_id + '/alertas-de-mudanca')
    },
    getProductBudgetOutOfStock: (orcamento_id, orcamento_item_id) => {
        return httpNoLoading.get('orcamento/' + orcamento_id + '/item/' + orcamento_item_id + '/alertas-mudanca-estoques');
    },
    getProductBudgetPriceMin: (orcamento_id, orcamento_item_id) => {
        return httpNoLoading.get('orcamento/' + orcamento_id + '/item/' + orcamento_item_id + '/alertas-mudanca-preco-minimo');
    },
    getProductMultiple: (orcamento_id, orcamento_item_id) => {
        return httpNoLoading.get('orcamento/' + orcamento_id + '/item/' + orcamento_item_id + '/alertas-multiplos');
    },
    cancelOrcamento: (id, motivoCancel) => {
        let data ={
            'motivo': motivoCancel
        }
        return http.put('orcamento/' + id + '/cancelar', data)
    },
    sendOrcamento: (id, pedidoData) => {
        return http.post('orcamento/' + id + '/enviar', pedidoData)
    },
    saveAceiteInformacoesOrcamento: (id, boAceiteInformacoesOrcamento) => {
        let data = {
            "bo_aceite_informacoes_orcamento": boAceiteInformacoesOrcamento == "S" || boAceiteInformacoesOrcamento === true ? "S" : "N"
        };
        return http.put('orcamento/' + id + '/aceite-informacoes', data)
    },
    duplicarOrcamento: (orcamento) => {
        return http.post('orcamento/duplicar', orcamento);
    },
    saveOrcamento: (orcamento, filial) => {
        let data = {
            "contato": orcamento.contato,
            "data_validade": orcamento.data_validade,
            "previsao_fechamento": orcamento.previsao_fechamento,
            "cd_filial": filial,
            "observacao": orcamento.observacao,
            "observacao_follow_up_interno": orcamento.observacao_follow_up_interno,
            "cd_tabelapreco": orcamento.cd_tabelapreco,
            "id_forma": orcamento.id_forma,
            "id_condicao": orcamento.id_condicao,
            "bo_aceite_informacoes_orcamento": orcamento.bo_aceite_informacoes_orcamento == "S" || orcamento.bo_aceite_informacoes_orcamento === true ? "S" : "N"
        };
        return http.put('orcamento/' + orcamento.id + '/salvar', data)
    },
    updateProducts: (id) => {
        return http.put('orcamento/' + id + '/atualizar-precos', null,  { silent: true })
    },
    deleteOrcamento: (id) => {
        return http.delete('orcamento/' + id)
    },
    deleteOrcamentoItem: (orcamento_id, id) => {
        return http.delete('orcamento/' + orcamento_id + '/item/' + id)
    },
    addOrcamentoItem: (orcamento_id, data) => {
        return httpNoLoading.post('orcamento/' + orcamento_id + '/item', data)
    },
    saveOrcamentoItem: (item) => {
        let data = {
            "quantidade": item.quantidade,
            "margem_valor": item.margem_valor,
            "margem_percentual": item.margem_percentual,
            "cd_filial": item.cd_filial
        };
        return httpNoLoading.put('orcamento/' + item.orcamento_id + '/item/' + item.id, data)
    },
    buscarOpcoesPagamento(pessoaFisica){
        let url = 'orcamento/opcoes-pagamentos'
        if(pessoaFisica == true){
            url += '?pessoafisica=true'
        }
        return http.get(url, { silent: true })
    }
}